let ocs_accordion = jQuery('.accordion__title a')

ocs_accordion.on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        thisParent = thisEl.parent()

    thisParent.toggleClass('open').next().slideToggle()

})

jQuery('.tab__sections li:first-child a').addClass('selected')

jQuery('.tab__sections a').on('click', function(e) {

    e.preventDefault()

    let parentLi = jQuery(this).parent()
    let parentLiIndex = parentLi.index()
    let wrapper = jQuery(this).parents('.tab')

    wrapper.find('.tab__sections a').removeClass('selected')
    jQuery(this).addClass('selected')

    wrapper.find('.tab__content').hide().eq(parentLiIndex).show()

    console.log(parentLiIndex)

})
